<template>
  <div class="sg-user-auth-container">
    <!-- Desktop -->
    <div class="sg-ua-background-container" v-if="isDesktop">
      <div class="sg-ua-background" :class="[slide]">
        <transition name="slide-fade" mode="out-in">
          <div :key="title">
            <span class="display-4">{{ title }}</span>
            <p>{{ message }}</p>
          </div>
        </transition>
        <b-img
          :src="require('@/assets/img/fullwidth/about-us.png')"
          v-on:load="onLoaded"
          style="width: 80%;"
        />
      </div>
    </div>

    <div class="sg-float-left-container" :class="[slide]" v-if="isDesktop">
      <div class="sg-float-left">
        <ButtonClose route="Home" text="Close" />

        <div class="sg-login-form">
          <FormLogin :whereTo="this.$route.params.whereTo" />

          <span class="cursor-pointer" @click="slides">
            Create an Account
          </span>

          &emsp;|&emsp;

          <span class="cursor-pointer">
            <router-link style="text-decoration: none; color: #2c3e50;" tag="a" :to="{ name: 'ResetPassword'}">Forgot Password ?</router-link>
          </span>
        </div>
      </div>
    </div>

    <div class="sg-float-right-container" :class="[slide]" v-if="isDesktop">
      <div class="sg-float-right">
        <ButtonClose route="Home" text="Close" />

        <div class="sg-register-form">
          <transition name="fade">
            <FormRegisterCustomer v-if="show_customer" />
          </transition>

          <transition name="fade">
            <FormRegisterGuider v-if="show_guider" />
          </transition>

          <transition name="fade">
            <div v-if="show_customer">
              <span class="cursor-pointer" @click="slides">
                Already a member ?
              </span>

              &emsp;|&emsp;

              <span class="cursor-pointer" @click="turns">
                Become Our Guider
              </span>
            </div>
          </transition>

          <transition name="fade">
            <div v-if="show_guider">
              <span class="cursor-pointer" @click="turns">
                Create Regular Account
              </span>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <!-- Mobile -->
    <div class="sg-ua-background-container" v-if="isMobile">
      <div class="sg-ua-background px-5" :class="[slide]">
        <transition name="slide-fade" mode="out-in">
          <div :key="title">
            <span style="font-size: 34px;">{{ title }}</span>
            <p>{{ message }}</p>
          </div>
        </transition>
        <b-img
          :src="require('@/assets/img/fullwidth/about-us.png')"
          v-on:load="onLoaded"
          style="width: 100%;"
        />
      </div>
    </div>

    <div class="sg-float-left-container" :class="[slide]" v-if="isMobile">
      <div class="sg-float-left">
        <ButtonClose route="Home" text="Close" />

        <div class="sg-login-form">
          <FormLogin :whereTo="this.$route.params.whereTo" />

          <span class="cursor-pointer" @click="slides">
            Create an Account
          </span>

          &nbsp;|&nbsp;

          <span class="cursor-pointer">
            <router-link style="text-decoration: none; color: #2c3e50;" tag="a" :to="{ name: 'ResetPassword'}">Forgot Password ?</router-link>
          </span>
        </div>
      </div>
    </div>

    <div class="sg-float-right-container" :class="[slide]" v-if="isMobile">
      <div class="sg-float-right">
        <ButtonClose route="Home" text="Close" />

        <div class="sg-register-form">
          <transition name="fade">
            <FormRegisterCustomer v-if="show_customer" />
          </transition>

          <transition name="fade">
            <FormRegisterGuider v-if="show_guider" />
          </transition>

          <transition name="fade">
            <div v-if="show_customer">
              <span class="cursor-pointer" @click="slides">
                Already a member ?
              </span>

              &emsp;|&emsp;

              <span class="cursor-pointer" @click="turns">
                Become Our Guider
              </span>
            </div>
          </transition>

          <transition name="fade">
            <div v-if="show_guider">
              <span class="cursor-pointer" @click="turns">
                Create Regular Account
              </span>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// external dependencies

// custom component
import FormLogin from '@/templates/FormLogin'
import FormRegisterCustomer from '@/templates/FormRegisterCustomer'
import FormRegisterGuider from '@/templates/FormRegisterGuider'
import ButtonClose from '@/templates/ButtonClose'

// api call

export default {
  name: 'Login',
  components: {
    FormLogin,
    FormRegisterCustomer,
    FormRegisterGuider,
    ButtonClose
  },
  data () {
    return {
      isMobile: false,
      isDesktop: false,
      window: {
        width: 0,
        height: 0
      },

      title: '',
      message: '',
      slide: '',
      show_customer: true,
      show_guider: false,
      flag: true
    }
  },
  beforeCreate: function () {
    if (this.$session.exists()) {
      this.$router.push({ name: 'Home' })
    }
  },
  created: function () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // PREREQUISITES
    handleResize: function () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight

      if (this.window.width < 575) {
        this.isMobile = true
        this.isDesktop = false
      } else if (this.window.width > 575) {
        this.isMobile = false
        this.isDesktop = true
      }
    },

    showLeft: function () {
      this.title = 'Welcome Back!'
      this.message = 'To keep connected with us please login with your personal info.'
      this.slide = 'showLeft'
      this.flag = false
    },
    showRight: function () {
      this.title = 'Hello, Friends!'
      this.message = 'Enter your personal details and start journey with us!'
      this.slide = 'showRight'
      this.flag = true
    },

    turns: function () {
      if (this.show_guider) {
        this.show_guider = false

        setTimeout(() => {
          this.show_customer = true
        }, 500)
      } else if (this.show_customer) {
        this.show_customer = false

        setTimeout(() => {
          this.show_guider = true
        }, 500)
      }
    },
    slides: function () {
      if (this.flag) {
        this.showLeft()
      } else {
        this.showRight()
      }
    },
    onLoaded: function () {
      let currentRoute = this.$router.currentRoute.name
      let timeOut = 0

      if (this.isMobile) {
        timeOut = 1000
      } else {
        timeOut = 500
      }

      if (currentRoute === 'Login') {
        setTimeout(
          () => (this.showLeft()),
          timeOut
        )
      } else {
        setTimeout(
          () => (this.showRight()),
          timeOut
        )
      }
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
  /* Background style */
  .sg-user-auth-container {
    z-index: 10;
    width: 100vw;
    height: 100vh;

    background-color: #233c7c;
  }
  .sg-ua-background-container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sg-ua-background {
    position: absolute;

    color: white;
    text-align: center;
  }
  @media screen and (max-width: 575px) {
    .sg-ua-background {
      width: 100vw;
    }
  }
  @media screen and (min-width: 576px) {
    .sg-ua-background {
      width: 50vw;
    }
  }
  /* END Background style */

  /* Form style */
  .sg-float-left-container,
  .sg-float-right-container {
    position: absolute;
    z-index: 20;
    top: 0;
  }
  @media screen and (max-width: 575px) {
    .sg-float-left-container,
    .sg-float-right-container {
      width: 100vw;
      height: 60vh;
    }
  }
  @media screen and (min-width: 576px) {
    .sg-float-left-container,
    .sg-float-right-container {
      width: 50vw;
      height: 100vh;
    }
  }

  .sg-float-left,
  .sg-float-right {
    height: calc(100% - 20px);
    display: flex;
    align-items: center;
    justify-content: center;

    margin: 10px;
    border-radius: 15px;
    background-color: #fafafa;
  }

  .sg-login-form,
  .sg-register-form {
    text-align: center;
  }
  @media screen and (max-width: 575px) {
    .sg-login-form,
    .sg-register-form {
      width: 100vw;
    }
  }
  @media screen and (min-width: 576px) {
    .sg-login-form,
    .sg-register-form {
      width: 40vw;
    }
  }
  /* END Form style */

  /* Slides Transition */
  .showLeft,
  .showRight {
    -webkit-transition: 0.75s;
    -moz-transition: 0.75s;
    -ms-transition: 0.75s;
    -o-transition: 0.75s;
    transition: 0.75s;
  }

  @media screen and (max-width: 575px) {
    .sg-ua-background,
    .sg-float-left-container,
    .sg-float-right-container {
      left: 0;
    }

    /* Start state */
    .sg-ua-background {
      top: 25%;
    }
    .sg-float-left-container {
      top: -100%;
    }
    .sg-float-right-container {
      top: -100%;
    }

    /* Show left state */
    .sg-ua-background.showLeft {
      top: 0% !important;
    }
    .sg-float-left-container.showLeft {
      top: 40% !important;
    }
    .sg-float-right-container.showLeft {
      top: -100% !important;
    }

    /* Show right state */
    .sg-ua-background.showRight {
      top: 0% !important;
    }
    .sg-float-left-container.showRight {
      top: -100% !important;
    }
    .sg-float-right-container.showRight {
      top: 40% !important;
    }
  }
  @media screen and (min-width: 576px) {
    .sg-float-left-container,
    .sg-float-right-container {
      top: 0;
    }

    /* Start state */
    .sg-ua-background {
      left: 25%;
    }
    .sg-float-left-container {
      left: -50%;
    }
    .sg-float-right-container {
      left: -50%; /* should be 100%, tp ada masalah scrolling */
    }

    /* Show left state */
    .sg-ua-background.showLeft {
      left: 50% !important;
    }
    .sg-float-left-container.showLeft {
      left: 0% !important;
    }
    .sg-float-right-container.showLeft {
      left: -50% !important; /* should be 100%, tp ada masalah scrolling */
    }

    /* Show right state */
    .sg-ua-background.showRight {
      left: 0% !important;
    }
    .sg-float-left-container.showRight {
      left: -50% !important;
    }
    .sg-float-right-container.showRight {
      left: 50% !important;
    }
  }
  /* END Slides Transition */

  /* Turns Transition */
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  /* END Turns Transition */

  /* .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s ease-in;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  } */
</style>



// WEBPACK FOOTER //
// src/views/Login.vue